/**
 * @Author: 左建
 * @Date: 2022/8/1 20:42
 * @LastEditTime: 2022/8/1 20:42
 * @Description: datePicker的一些配置项
*/
import { clearTime } from "element-ui/lib/utils/date-util"
export const DATE_FORMAT_BY_TYPE = Object.freeze({
    year: "yyyy",
    month: "yyyy-MM",
    date: "yyyy-MM-dd",
    week: "yyyy-WW",
    dates: "yyyy-MM-dd",
    datetime: "yyyy-MM-dd HH:mm:ss",
    datetimerange: "yyyy-MM-dd HH:mm:ss",
    daterange: "yyyy-MM-dd",
    monthrange: "yyyy-MM"
})

export const DATE_PLACEHOLDER_BY_TYPE = Object.freeze({
    datetimerange: ["开始时间", "结束时间"],
    daterange: ["开始日期", "结束日期"],
    monthrange: ["开始年月", "结束年月"]
})

function getRangePickerOptions (picker, day, type = "before", isRange) {
    const end = new Date()
    const start = new Date()
    if (type === "after") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * day)
        picker.$emit("pick", isRange ? [start, end] : start)
    } else {
        start.setTime(start.getTime() + 3600 * 1000 * 24 * day)
        picker.$emit("pick", isRange ? [end, start] : start)
    }
}
// 获取表单时间选择pickerOptions
export function getPickerOptions (isRange, disabled) {
    const textMap = {
        before: isRange ? "往后" : "后",
        after: isRange ? "最近" : "前"
    }
    const getText = (text) => isRange ? textMap[disabled] + text : text + textMap[disabled]
    const shortCuts = [
        {
            text: "今天",
            onClick (picker) {
                if (isRange) {
                    picker.$emit("pick", [clearTime(new Date()), new Date()])
                } else {
                    picker.$emit("pick", new Date())
                }
            }
        },
        {
            text: isRange ? textMap[disabled] + "一天" : disabled === "before" ? "明天" : "昨天",
            onClick (picker) {
                getRangePickerOptions(picker, 1, disabled, isRange)
            }
        },
        {
            text: isRange ? textMap[disabled] + "两天" : disabled === "before" ? "后天" : "前天",
            onClick (picker) {
                getRangePickerOptions(picker, 2, disabled, isRange)
            }
        },
        {
            text: getText("三天"),
            onClick (picker) {
                getRangePickerOptions(picker, 3, disabled, isRange)
            }
        },
        {
            text: getText("一周"),
            onClick (picker) {
                getRangePickerOptions(picker, 7, disabled, isRange)
            }
        },
        {
            text: getText("一个月"),
            onClick (picker) {
                getRangePickerOptions(picker, 30, disabled, isRange)
            }
        },
        {
            text: getText("两个月"),
            onClick (picker) {
                getRangePickerOptions(picker, 60, disabled, isRange)
            }
        },
        {
            text: getText("三个月"),
            onClick (picker) {
                getRangePickerOptions(picker, 90, disabled, isRange)
            }
        },
        {
            text: getText("半年"),
            onClick (picker) {
                getRangePickerOptions(picker, 180, disabled, isRange)
            }
        },
        {
            text: getText("一年"),
            onClick (picker) {
                getRangePickerOptions(picker, 365, disabled, isRange)
            }
        }
    ]
    return {
        shortcuts: shortCuts,
        disabledDate (t) {
            if (disabled === "after") return t.getTime() > new Date().getTime()
            return t.getTime() < new Date().getTime() - 3600 * 24 * 1000
        },
        onPick (vm) {
            //
        }
    }
}

// 获取禁用的时间段
export function getDisabledTime (disabled) {
    const data = new Date()
    if (disabled === "after") {
        return [`00:00:00-${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`]
    } else {
        return [`${data.getHours()}:${data.getMinutes()}:${data.getSeconds()} - 23:59:59`]
    }
}
